/* „Skomponuj własny zestaw” (sections/sb-zestawy.liquid): the card is re-rendered from the section (Shopify's section rendering) whenever the cart changes, so it counts jars exactly
   as the cart card does (snippets/sb-set-pool-of.liquid), with the prices the cart really has. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // the cross shows only where the cart engine can take one jar out (assets/sb-cart.js, SBCart.removeJar)
  const canRemove = () => !!(window.SBCart && typeof window.SBCart.removeJar === 'function');
  const markRemove = () => document.documentElement.classList.toggle('sbz-can-remove', canRemove());
  window.addEventListener('DOMContentLoaded', markRemove);
  window.addEventListener('load', markRemove);

  function live(root, section) {
    let busy = false;
    let again = false;
    async function refresh() {
      if (busy) {
        again = true;
        return;
      }
      busy = true;
      const card = root.querySelector('[data-sbz-card]');
      card && card.classList.add('is-loading');
      try {
        const res = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(section)}`, {
          headers: { Accept: 'text/html' },
        });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-sbz-live] [data-sbz-card]');
        const old = root.querySelector('[data-sbz-card]');
        if (fresh && old) {
          // places that were not there before pop in (the gold ones once the first step is full); places that go burst first
          const oldSlots = old.querySelectorAll('.sbz-slot');
          const had = oldSlots.length;
          const now = fresh.querySelectorAll('.sbz-slot').length;
          fresh.querySelectorAll('.sbz-slot').forEach((el, i) => {
            if (i >= had) el.classList.add('is-new');
          });
          if (now < had && !reduceMotion) {
            for (let i = now; i < had; i += 1) oldSlots[i].classList.add('is-gone');
            await new Promise((r) => setTimeout(r, 260));
          }
          if (!old.isConnected) return;
          // keep the bar's own canvas: the fresh markup gets the drawn one with the new numbers on it, so the shared bar
          // (assets/sb-glitter-bar.js) moves on from what is painted. A new canvas swapped in right after load stayed blank at 0
          // jars (3 Nov: 0 painted pixels after a refresh, 22 176 without one), because at an empty fill nothing paints it again.
          const oc = old.querySelector('canvas[data-sb-glitter]');
          const nc = fresh.querySelector('canvas[data-sb-glitter]');
          if (oc && nc && oc.dataset.sbGlitter === nc.dataset.sbGlitter) {
            [...nc.attributes].forEach((a) => oc.setAttribute(a.name, a.value));
            nc.replaceWith(oc);
          }
          old.replaceWith(fresh);
          // the shared bar (assets/sb-glitter-bar.js) picks up the new canvas and fills on from where it was
          document.dispatchEvent(new CustomEvent('sb:glitter', { detail: { root: fresh } }));
        }
      } catch (e) {
        // the tray keeps what it showed; the cart itself is unaffected
      } finally {
        const card2 = root.querySelector('[data-sbz-card]');
        card2 && card2.classList.remove('is-loading');
        busy = false;
        if (again) {
          again = false;
          refresh();
        }
      }
    }
    // his 3 Nov: a filled place can be emptied from here. Tap a place (or point at it) → its cross; the cross takes one jar out
    // through the cart's own engine, which prices the set again and announces the cart (→ refresh above). Tap elsewhere → no cross.
    root.addEventListener('click', async (e) => {
      const x = e.target.closest('[data-sbz-remove]');
      const slot = e.target.closest('.sbz-slot.is-in');
      if (x && slot && canRemove()) {
        e.preventDefault();
        slot.classList.add('is-removing');
        let ok = false;
        try {
          ok = await window.SBCart.removeJar({ set: slot.dataset.set, variant: slot.dataset.sbzJar, title: slot.dataset.title });
        } catch (err) {}
        if (!ok && slot.isConnected) slot.classList.remove('is-removing');
        return;
      }
      if (slot && canRemove()) {
        const was = slot.classList.contains('is-armed');
        root.querySelectorAll('.sbz-slot.is-armed').forEach((s) => s.classList.remove('is-armed'));
        if (!was) slot.classList.add('is-armed');
      }
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.sbz-slot.is-in')) root.querySelectorAll('.sbz-slot.is-armed').forEach((s) => s.classList.remove('is-armed'));
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh());
    }
    // another tab, or the cart changed while this page was in the background
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refresh();
    });
  }

  function init() {
    document.querySelectorAll('[data-sbz]').forEach((el) => {
      const l = el.querySelector('[data-sbz-live]');
      if (l) live(l, el.dataset.section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
